import { motion } from 'framer-motion';
import styled from 'styled-components';

const HEADER_HEIGHT = 60;

export const NavUnauthSC = styled(motion.nav)`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  height: ${HEADER_HEIGHT}px;

  z-index: 9999;

  padding: 0 16px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: box-shadow 0.3s;

  color: #333d6c;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);

  .auth-menu-open-overflown &,
  .auth-menu-open & {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1) !important;
  }

  .logo {
    display: flex;
    align-items: center;
    justify-content: center;

    text-decoration: none !important;
    cursor: pointer;
  }

  .nav-right {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    .lang-switcher {
      width: 106.79px;
    }

    .hamburger {
      display: none;
      margin-left: 16px;
      border: none;
      background: none;
      outline: none;
      cursor: pointer;
    }

    .user {
      margin-left: 16px;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      height: 100%;

      display: flex;
      align-items: center;
      justify-content: center;

      .separator {
        border-left-width: 1px;
        border-left-style: solid;
        padding-left: 16px;
        height: 100%;
        opacity: 0.2;
      }

      .logout-btn {
        background: none;
        outline: none;
        border: none;
        cursor: pointer;
      }
    }
  }

  @media only screen and (max-width: 900px) {
    .nav-right {
      .hamburger {
        display: block;
      }
    }
  }
`;

export const MobileMenuSC = styled.div`
  position: fixed;
  inset: 0;
  background: white;
  z-index: 9998;

  display: flex;
  flex-direction: column;

  overflow: auto;

  padding: 16px;
  padding-top: ${HEADER_HEIGHT}px;

  transition: all 0.3s;

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    padding: 16px 0;

    .user-name {
      margin-top: 8px;
      font-weight: bold;
    }

    .user-email {
      opacity: 0.3;
    }
  }

  &.auth-menu-enter {
    opacity: 0;
  }
  &.auth-menu-enter-active {
    opacity: 1;
  }
  &.auth-menu-exit {
    opacity: 1;
  }
  &.auth-menu-exit-active {
    opacity: 0;
  }
`;
